var _rect, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenGradientBg480X600(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481,
    height: 600,
    viewBox: "0 0 481 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.814453,
    width: 480,
    height: 600,
    rx: 90,
    fill: "url(#paint0_linear_2_3031)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.968 184.5C479.947 184.705 479.761 184.871 479.553 184.871C371.532 184.871 118.393 202.384 0.400405 218.617C0.191352 218.646 0.0150365 218.505 0.00659449 218.302C-0.00184848 218.1 0.160779 217.912 0.369833 217.883C118.396 201.646 371.571 184.13 479.629 184.13C479.838 184.13 479.989 184.295 479.968 184.5Z",
    fill: "#BFD9C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.305 451.176C147.346 482.11 58.9709 517.262 4.35229 540.324C4.172 540.4 3.92581 540.317 3.80241 540.138C3.679 539.959 3.72511 539.752 3.9054 539.675C58.5344 516.609 146.924 481.451 236.901 450.511C326.866 419.575 418.456 392.844 479.472 386.65C479.68 386.628 479.902 386.768 479.968 386.962C480.034 387.155 479.919 387.329 479.711 387.35C418.793 393.534 327.275 420.239 237.305 451.176Z",
    fill: "#EDFFF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.597 105.324C148.731 118.946 57.7627 136.208 0.46085 148.117C0.258398 148.159 0.0602248 148.029 0.0182187 147.826C-0.0237875 147.623 0.10628 147.425 0.308732 147.383C57.6211 135.471 148.604 118.206 239.486 104.582C330.359 90.9594 421.166 80.9711 478.111 83.6252C478.318 83.6348 478.477 83.8103 478.468 84.0172C478.458 84.2241 478.283 84.384 478.076 84.3744C421.214 81.7241 330.473 91.7007 239.597 105.324Z",
    fill: "#BFD9C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.138 115.996C152.123 120.181 60.0443 127.948 0.367709 133.862C0.155363 133.883 -0.00909192 133.738 0.000390285 133.538C0.00987399 133.338 0.189701 133.159 0.402049 133.138C60.0885 127.222 152.183 119.455 243.215 115.268C334.238 111.083 424.235 110.475 479.706 118.89C479.909 118.921 480.022 119.107 479.959 119.306C479.895 119.505 479.679 119.641 479.476 119.61C424.088 111.208 334.162 111.81 243.138 115.996Z",
    fill: "#BFD9C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.394 78.5718C156.562 73.9051 63.7189 72.6593 3.28529 72.3368C3.06558 72.3357 2.92979 72.1839 2.982 71.9978C3.03421 71.8118 3.25466 71.6619 3.47437 71.6631C63.9138 71.9856 156.773 73.2315 247.625 77.8993C338.466 82.5664 427.342 90.6563 479.792 104.677C479.989 104.729 480.058 104.917 479.947 105.095C479.836 105.274 479.587 105.376 479.39 105.323C427.031 91.3268 338.238 83.2392 247.394 78.5718Z",
    fill: "#BFD9C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_3031",
    x1: 240.814,
    y1: 0,
    x2: 240.814,
    y2: 600,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580345,
    stopColor: "#008080",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008080",
    stopOpacity: 0.26
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenGradientBg480X600);
export default __webpack_public_path__ + "static/media/green-gradient-bg-480x600.ba50cc8820e75a576e8a4667c5df8b6d.svg";
export { ForwardRef as ReactComponent };